// Source: app/scripts/controllers/individuals-for-approval.js
/**
 * Created by ristes on 20.4.15.
 */





Auction.controller('IndividualsForApprovalController', [
  '$scope',
  '$filter',
  '$modal',
  'crudService',
  'toaster',
  function ($scope, $filter, $modal, crudService, toaster) {

    var service = crudService('registered_users', {
      enable: {
        method: 'POST',
        url: "/data/rest/registered_users/enable"
      },
      disable: {
        method: 'POST',
        url: "/data/rest/registered_users/disable"
      },
      getLog: {
        method: 'GET',
        url: '/data/rest/users/log',
        isArray: true
      },
      getBankGuarantees: {
        method: 'GET',
        url: '/data/rest/bank_guarantees/by_username',
        isArray: true
      },
      editIndividualUser: {
        method: 'POST',
        url: "/data/rest/registered_users/edit_individual_user"
      },
      resendConfirmationUrl: {
        method: 'POST',
        url: "/data/rest/registered_users/manually_resend_confirmation_urls"
      }


    });


    $scope.crudTitle = "portal.individuals";
    $scope.disableEntity = {};
    $scope.modalDisable = $modal({
      scope: $scope,
      template: 'forms/modals/disable.html',
      show: false
    });

    $scope.disable = function () {
      service.disable({
        username: $scope.disableEntity.username,
        days: $scope.disableEntity.days
      }, function () {
        $scope.modalDisable.hide();
        delete $scope.disableEntity.days;
        $scope.personsCrud.reload();
        $scope.personsCrud.edit($scope.disableEntity.id);
        $scope.disableEntity = {};
      });
    };

    $scope.onSelect = function (crudScope, entity) {
      crudScope.log = service.getLog({
        code: entity.username
      });
      crudScope.bankGuarantees = service.getBankGuarantees({
        username: entity.username
      });
    };

    $scope.actions = [{
      text: 'eauction.enable',
      name: 'enable',
      position: 'right',
      classes: 'btn btn-primary',
      iconClass: 'fa fa-fw fa-toggle-on',
      enabled: false,
      onClick: function (entity) {
        service.enable({
          username: entity.username
        }, function () {
          $scope.personsCrud.reload();
          $scope.personsCrud.edit(entity.id);
        });
      }
    }, {
      text: 'eauction.disable',
      name: 'disable',
      position: 'right',
      classes: 'btn btn-primary',
      iconClass: 'fa fa-fw fa-toggle-off',
      enabled: false,
      onClick: function (entity) {
        $scope.disableEntity = entity;
        $scope.modalDisable.$promise.then($scope.modalDisable.show);
      }
    }];

    $scope.resendConfirmationUrl = function () {
      service.resendConfirmationUrl();
    };


    $scope.afterInit = function (crudScope) {

      crudScope.disableUser =  function (entity) {
        $scope.disableEntity = entity;
        $scope.modalDisable.$promise.then($scope.modalDisable.show);
      };


      crudScope.enableUser = function (entity) {
        service.enable({
          username: entity.username
        }, function () {
          $scope.personsCrud.reload();
          $scope.personsCrud.edit(entity.id);
        });
      };



    };

    $scope.save = function (entity) {
      service.editIndividualUser(entity, function (data) {
        console.log('za cudo sum vo funkcijata');
      })
    }




  }
]);
